import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Button } from "react-bootstrap";

const ExportExcel = ({ tableId, filename = "report.xlsx" }) => {
  const downloadExcel = () => {
    const table = document.getElementById(tableId);
    if (!table) {
      console.error(`Table with id="${tableId}" not found`);
      return;
    }

    const rows = [...table.querySelectorAll("tr")];
    if (rows.length === 0) return;

    // Get column indexes where the header text is "Action"
    const headerCells = [...rows[0].cells];
    const actionIndexes = headerCells
      .map((cell, index) =>
        cell.innerText.trim().toLowerCase() === "action" ? index : -1
      )
      .filter((index) => index !== -1);

    // Convert table to 2D array while skipping "Action" columns
    const data = rows.map((row) => {
      const cells = [...row.cells];
      return cells
        .filter((_, index) => !actionIndexes.includes(index))
        .map((cell) => cell.innerText);
    });

    // Create worksheet from filtered data
    const ws = XLSX.utils.aoa_to_sheet(data);

    // Create workbook and append sheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    // Export as file
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, filename);
  };

  return (
    <Button variant="success" onClick={downloadExcel} id="CSV">
      Export Excel
    </Button>
  );
};

export default ExportExcel;
